import { useSyncExternalStore } from "react";
import { Workbox } from "workbox-window";

const DISMISS_KEY = "jatak_install_dismissed";
const subs = new Set();
let deferredPrompt = null;
let wb = null;
let snap = {
  canPrompt: false,
  updateReady: false,
  iosSheet: false,
  dismissed: typeof localStorage !== "undefined" && localStorage.getItem(DISMISS_KEY) === "1",
};

const set = (patch) => {
  snap = { ...snap, ...patch };
  subs.forEach((f) => f());
};
const subscribe = (f) => {
  subs.add(f);
  return () => subs.delete(f);
};

export const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const isIOS = () =>
  /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferredPrompt = e;
  set({ canPrompt: true });
});
window.addEventListener("appinstalled", () => {
  deferredPrompt = null;
  set({ canPrompt: false });
});

export function registerSW() {
  if (!("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    if (process.env.NODE_ENV !== "production") {
      navigator.serviceWorker.register("/dev-sw.js").catch(() => {});
      return;
    }
    wb = new Workbox("/service-worker.js");
    wb.addEventListener("waiting", () => set({ updateReady: true }));
    wb.register().catch(() => {});
    const check = () => document.visibilityState === "visible" && wb.update().catch(() => {});
    document.addEventListener("visibilitychange", check);
    setInterval(check, 60 * 60 * 1000);
  });
}

export function applyUpdate() {
  if (!wb) return window.location.reload();
  wb.addEventListener("controlling", () => window.location.reload());
  wb.messageSkipWaiting();
}

export async function install() {
  if (deferredPrompt) {
    const p = deferredPrompt;
    deferredPrompt = null;
    set({ canPrompt: false });
    p.prompt();
    await p.userChoice.catch(() => null);
    return;
  }
  if (isIOS()) set({ iosSheet: true });
}

export const closeIosSheet = () => set({ iosSheet: false });
export function dismissInstall() {
  localStorage.setItem(DISMISS_KEY, "1");
  set({ dismissed: true });
}

export function usePwa() {
  const s = useSyncExternalStore(subscribe, () => snap);
  const standalone = isStandalone();
  return { ...s, standalone, ios: isIOS(), canInstall: !standalone && (s.canPrompt || isIOS()) };
}
